export const PROJECT_NAME = 'requests'
